import { Action } from 'redux'

import { AuthStatus } from './reducer'
import { User } from '../../lib/interfaces/User.interface'

export const actionTypes = {
  AUTH_ERROR: 'AUTH_ERROR',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_USER_SET: 'AUTH_USER_SET',
  AUTH_TOKEN_SET: 'AUTH_TOKEN_SAVE',
  AUTH_STATUS_SET: 'AUTH_STATUS_SET',
  AUTH_ASSUME_ROLE: 'AUTH_ASSUME_ROLE'
}

/**
 * Save Token
 */
export interface TokenSetAction extends Action {
  type: typeof actionTypes.AUTH_TOKEN_SET,
  payload: {
    accessToken: string
    next?: (err?: any, user?: User) => void
  }
}

export const tokenSave = (accessToken: string, next?: (err: any, user: User) => void): TokenSetAction => ({
  payload: { accessToken, next },
  type: actionTypes.AUTH_TOKEN_SET,
})

/**
 * Set User
 */
export interface UserSetAction extends Action {
  type: typeof actionTypes.AUTH_USER_SET
  payload: {
    user: User,
  }
}

export const setUser = (user: User): UserSetAction => ({
  payload: { user },
  type: actionTypes.AUTH_USER_SET,
})


/**
 * Auth Error
 */
export interface AuthErrorAction extends Action {
  type: typeof actionTypes.AUTH_USER_SET,
  payload: {
    err: string
  }
}

export const authError = (err: string): AuthErrorAction => ({
  payload: { err },
  type: actionTypes.AUTH_ERROR,
})

/**
 * Auth Logout
 */
export const authLogout = () => ({
  type: actionTypes.AUTH_LOGOUT,
})

/**
 * Auth Set Status
 */
export interface AuthStatusSetAction extends Action {
  payload: {
    status: AuthStatus
  }
}

export const setAuthStatus = (status: AuthStatus): AuthStatusSetAction => ({
  type: actionTypes.AUTH_STATUS_SET,
  payload: { status }
})

/**
 * Auth Assume Role
 */
export interface AuthAssumeRoleFromUserAction extends Action {
  payload: {
    user?: User
  }
}

export const assumeRoleFromUser = (user?: User): AuthAssumeRoleFromUserAction => ({
  type: actionTypes.AUTH_ASSUME_ROLE,
  payload: { user }
})

/**
 * Action Types
 */
export type ActionTypes = TokenSetAction
  | UserSetAction
  | AuthErrorAction
  | AuthStatusSetAction



// WEBPACK FOOTER //
// ./src/store/auth/actions.ts